package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_03_01_Day_1
import com.veldekar.components.logs.Log_2025_03_01_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-03-01")
@Composable
public fun Log_2025_03_01(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Moo!",
        ogTitle = "Moo!",
        date = LocalDate(2_025, 3, 1),
        ogDescription = "Having concluded the primary cow narrative, the heroes begin their next cow narrative.",
        ogImage = "ai/2025-03-01.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-77", dateString = "Newgrowth 77")
        Log_2025_03_01_Day_1()
        SessionDayHeader(dayId = "newgrowth-78", dateString = "Newgrowth 78")
        Log_2025_03_01_Day_2()
    }
}
